import { Switch as MuiSwitch } from "@mui/material";
import { withStyles } from "@mui/styles";
import { C_DROPDOWN_HOVER, C_OUTLINE_VARIANT, C_PRIMARY, C_PRIMARY_DISABLED } from "~/common/components/icon/Colors";

export const Switch = withStyles({
  root: {
    marginLeft: -12,
    marginRight: -12,
    height: "auto",
  },
  switchBase: {
    padding: 8,
  },
  thumb: {
    height: "16px",
    width: "16px",
    color: "white",
    border: `1px solid ${C_OUTLINE_VARIANT}`,
    boxShadow: "none",
  },
  track: {
    width: "32px",
    height: "8px",
    opacity: 1,
    background: C_DROPDOWN_HOVER,
  },
  colorPrimary: {
    "&.Mui-checked": {
      "& .MuiSwitch-thumb": {
        borderColor: C_PRIMARY,
        background: C_PRIMARY,
      },
      "& + .MuiSwitch-track": {
        background: C_PRIMARY_DISABLED,
      },
    },
  },
})(MuiSwitch);
